import type { FunctionsError } from 'firebase/functions';

export const cloudFunctionErrorHandler = (e: unknown | Error | FunctionsError) => {
  if (typeof e === 'object' && e !== null && 'code' in e && typeof e.code === 'string') {
    if (e.code === 'permission-denied') {
      return {
        code: 403,
        error: e,
      };
    }

    return {
      code: e.code === 'not-found' ? 404 : 500,
      error: e,
    };
  }

  return {
    code: 500,
    error: e,
  };
};
